import { WELLHUB_USC_FLOW_FLAG } from 'hooks/useUscWellhubFlow';
import { WELLHUB_CLUB_FLAG } from 'hooks/useWellhubClub';
import type { AppRouterContext } from 'providers/AppRouter';
import type { OppFlowFlags } from 'services/partnersSelfSignup/opportunity';

/**
 * The flags of the verified Opportunity key, for code that hooks cannot reach (`beforeLoad`, loaders and `onVerified`). It reads the GrowthBook instance from router context, so call it after the attributes it depends on are updated. Components read the same flags with `useOppFlowFlags`.
 */
export function readOppFlowFlags(
  growthbook: AppRouterContext['growthbook'],
): OppFlowFlags {
  return {
    isUscFlow: growthbook.isOn(WELLHUB_USC_FLOW_FLAG),
    isClubFlow: growthbook.isOn(WELLHUB_CLUB_FLAG),
  };
}
